export default {
  upload: "UPLOAD",
  upload_file: "UPLOAD FILE",
  login: "LOGIN",
  logout: "LOGOUT",
  manage: 'MANAGE',
  recover: "RECOVER",
  login_with_okta: "LOGIN WITH OKTA",
  change_password: "CHANGE PASSWORD",
  check_user_role: "CHECKING USER ROLE ...",
  check_user_role_failed: "YOU DO NOT HAVE ROLE, PLEASE TRY TO LOGIN AGAIN.",
  login_again: "LOGIN AGAIN",
  supported_file_types: "SUPPORTED FILE TYPES",
  preview: "PREVIEW",
  select: "SELECT",
  reset_pwd: "RESET PASSWORD",
  create: "CREATE",
  batch_notice: 'BATCH NOTICE',
  batch_remove: 'BATCH REMOVE',
  export_list: 'EXPORT ATTENDEE LIST',
  send_notice: 'NOTICE',
  password: {
    old: "OLD PASSWORD",
    new: "NEW PASSWORD",
  },
  role_switch: "BACK TO USER PORTAL",
  add_file: "ADD CHAPTER",
  add_success: "ADD SUCCESS",
  session_switch: "SESSION SWITCH",
  network_space: "NETWORK SPACE",
  zoom_meeting_room: "ZOOM MEETING ROOM",
  live_meeting_room: "LIVE MEETING ROOM",
  add_room: "ADD ROOM",
  notice_board: "NOTICE BOARD",
  notice: "NOTICE",
  qa: 'Q&A',
  template: "TEMPLATE",
  copy_attendee: "COPY ATTENDEE",
  copy_session: "COPY SESSION",
  tag: "TAG",
  company: "COMPANY",
  'CORE': 'CORE',
  'NONCORE': 'NON CORE',
  partner_pool: "USER POOL",
  application: 'APPLICATION',
  error: "ERROR",
  associated_property: "ASSOCIATED PROPERTY",
  recommend: "RECOMMEND",
  cover: "COVER",
  short_note: "SHOT MESSAGE",
  email_note: "EMAIL MESSAGE",
  app: {
    name: 'APP NAME',
    add_application: 'ADD APP',
    edit_application: 'EDIT APP',
    scene_code: 'SCENE CODE',
    scene_code_config: 'SCENE CODE CONFIG',
    scene_code_list: 'SCENE CODE LIST',
    apply_scene_code: 'ENABLE SCENE CODE',
    add_scene_code: 'ADD SCENE CODE',
    app_binding: 'APP BINDING',
    enable: 'ENABLE',
    disable: 'DISABLE',
    add_edit_warn: 'APP NAME AND URL SHOULD NOT EMPTY'
  },
  channel: {
    create_channel: "CREATE CHANNEL",
    edit_channel: "EDIT CHANNEL",
    channel_name: "CHANNEL NAME",
    broadcaster: "BROADCASTER",
    view_bind_session: "VIEW BIND SESSION",
    query_session_input_placeholder: "PLEASE ENTER THE NAME OF THE EVENT/MEETING",
    query_session_date_placeholder: "PLEASE ENTER THE DATE RANGE FOR THE SESSION"
  },
  sport_name: "SPORT NAME",
  sport_date: "SPORT DATE",
  sport_item: "SPORT_ TEM",
  deadline: "DEADLINE",
  check_in_lead_time: 'EARLY ENTRY TIME',
  registration_time: "REGISTRATION TIME",
  sport_setting: "SPORT SETTING",
  sport_notice: "SPORT ANNOUNCEMENT",
  project_notice: "PROJECT ANNOUNCEMENT",
  location: "LOCATION",
  tip: "TIP",
  peoples: "NUMBER OF PEOPLE",
  sport: {
    name: "SPORT",
    input_sport_name: "PLEASE ENTER THE SPORT NAME",
    date: "DATE",
    stage: "STAGE",
    ready: "READY STAGE",
    registration: "REGISTRATION STAGE",
    activity: "ACTIVITY STAGE",
    end: "END STAGE",
    message: {
      name: "THE SPORT NAME CANNOT BE EMPTY",
      sport_date: "THE SPORT DATE CANNOT BE EMPTY",
      deadline: "THE DEADLINE CANNOT BE EMPTY",
      appointment_time: "THE APPOINTMENT TIME CANNOT BE EMPTY",
      sport_item: "THE SPORT ITEM CANNOT BE EMPTY"
    }
  },
  sport_detail: {
    name: "SPORT DETAIL",
    item_list: "PROJECT LIST",
    item_name: "PROJECT NAME",
    check_list: "CHECK LIST",
    sport_announcement: "SPORT ANNOUNCEMENT",
    appraise: "APPRAISE",
    upload_wonderful_moments: "UPLOAD WONDERFUL MOMENTS",
    item_name: "PROJECT NAME",
    item_description: "PROJECT INTRODUCTION",
    item_date: "PROJECT DATE",
    item_time: "PROJECT TIME",
    project_introduction_image: "PROJECT INTRODUCTION IMAGE",
    score: "SCORE",
    message: {
      item_name: "THE PROJECT NAME CANNOT BE EMPTY",
      item_date: "THE PROJECT DATE CANNOT BE EMPTY",
      item_time: "THE PROJECT TIME CANNOT BE EMPTY",
      location: "THE LOCATION CANNOT BE EMPTY",
      item_introduction: "THE PROJECT INTRODUCTION CANNOT BE EMPTY"
    }
  },
  admin: "ADMIN",
  chat_block_word: "SENSITIVE WORDS",
  playlist_types: "PLAYLIST TYPES",
  auto_playlist: "AUTO PLAYLIST",
  manual_playlist: "MANUAL PLAYLIST",
  video_manage: "VIDEO MANAGEMENT",
  channel_manage: "CHANNEL MANAGE",
  help_center: "eMoment HELP DESK",
  event_management: "EVENT MANAGEMENT",
  bi_report: "REPORT",
  event: "EVENT",
  recent_events: "RECENT EVENTS",
  warning: "WARNING",
  hint: "HINT",
  account_group: "ACCOUNT GROUP",
  upload_video: "UPLOAD VIDEO",
  upload_image: "UPLOAD IMAGE",
  view_image: "VIEW IMAGE",
  time: 'TIME',
  answer_status: 'ANSWER STATUS',
  all: 'ALL',
  answered: 'ANSWERED',
  unanswered: 'NOT ANSWERED',
  content: 'CONTENT',
  new_ask: 'NEW ASK',
  ask_time: 'ASK TIME',
  snapshot: 'ASK SNAPSHOT',
  answer: 'ANSWER',
  no_resources: "NO RESOURCES",
  general: "GENERAL",
  playback: "PLAYBACK",
  recorded: "RECORDED",

  //活动阶段
  event_stage: {
    '准备阶段': 'PREPARATION STAGE',
    '注册阶段': 'REGISTRATION STAGE',
    '活动阶段': 'EVENT BEGIN STAGE',
    '活动结束': 'EVENT END STAGE'
  },
  event_stage_check: {
    stage_check: 'EVENT STAGE CHECK',
    stage_switch: 'STAGE SWITCH',
    check_result: 'CHECK RESULT',
    rule: 'RULE',
    is_passed: 'PASS',
    message: 'MESSAGE',
    pass: 'PASSED',
    fail: 'FIALED',
    fixed: "FIXED",
    not_fixed: "NOT FIXED",
  },
  send_all: "SEND TO ALL ATTENDEES",
  send_already: "SEND UNANNOUNCED ATTENDEE",
  stage_check_rules: {
    '是否维护至少一个活动管理员': 'WHETHER TO MAINTAIN AT LEAST ONE ACTIVE ADMINISTRATOR',
    "发现管理员": "DISCOVERING AN ADMINISTRATOR"
  },
  //相关操作
  add: "ADD",
  operate: "ACTION",
  download: "DOWNLOAD",
  edit: "EDIT",
  use: "USE",
  in_use: "IN USE",
  delete: "DELETE",
  save: "SAVE",
  cancel: "CANCEL",
  submit: "SUBMIT",
  search: "SEARCH",
  clear: "CLEAR",
  clear_result: "CLEAR RESULT",
  disable: "DISABLE",
  enable: "ENABLE",
  detail: "DETAIL",
  back: "BACK",
  publish: "PUBLISH",
  action: "ACTION",
  REMOVE: "REMOVE",
  close: "CLOSE",
  copy: "COPY",
  on: "ON",
  off: "OFF",
  confirm: "CONFIRMED",
  sort: "SORT",
  other: "OTHERS",
  more: "MORE",
  unbind: "UNBIND",
  inform: "INFORM",
  associate_meeting: "ASSOCIATE SESSION",
  associate_meeting_list: "ASSOCIATE MEETING LIST",
  session_list: 'SESSION LIST',
  "i.page.total": "TOTAL",
  "i.page.items": "ITEMS",
  "i.page.item": "ITEM",
  "i.page.goto": "GOTO",
  "i.page.p": "PAGE",

  check_report: "← PLEASE CHOOSE AND CHECK REPORT.",
  help_center_detail: {
    user_manual: "USER MANUAL",
    feature_description_video: "FEATURE DESCRIPTION VIDEO",
    FAQ: "FAQ",
    search_placeholder: "PLEASE ENTER A KEYWORD",
    table: {
      document_name: "DOCUMENT NAME",
      upload_time: "UPLOAD TIME",
      type: "TYPE",
      language_environment: "LANGUAGE ENVIRONMENT",
      state: "STATE",
      action: "ACTION",
      question: "QUESTION",
      answer: "ANSWER"
    },
    document_content: "DOCUMENT CONTENT",
    document_type: "DOCUMENT TYPE",
    user_role: "USER ROLE",
    document_state: "DOCUMENT STATE",
    document_upload: "UPLOAD DOCUMENT",
    type_selection: "SELECTION TYPE",
    state_selection: "SELECTION STATE",
    select_a_language_environment: "SELECT A LANGUAGE ENVIRONMENT",
    public: "PUBLIC",
    not_public: "NOT PUBLIC",
    upload_pdf_tip: "FILE EXTENSIONS SUPPORTED: PDF",
    play_video: "PLAY VIDEO",
    table_tip: "SORRY, I DIDN'T FIND ANY RESULTS. TRY A DIFFERENT KEYWORD",
    no_data: "NO DATA",
    history: "HISTORY",
    catalog: "CATALOG",
    system_admin: "SYSTEM ADMIN",
    event_admin: "EVENT ADMIN",
    attendee: "ATTENDEE",
    broadcaster: "BROADCASTER",
    partner_contactor: "PARTNER CONTACT",
    speaker: "SPEAKER",
    assistant: "SPECIALIST",
    general: "GENERAL",
    faq_feedback: "FEEDBACK",
    enter_question: "PLEASE ENTER A QUESTION",
    clear_the_history: "CLEAR HISTORY",
    no_content: "NO CONTENT",
    preparatory_phase: "PREPARATORY STAGE",
    registration_phase: "REGISTRATION STAGE",
    activity_phase: "EVENT BEGIN STAGE",
    activity_end: "EVENT END STAGE",
    solve_problem: "WHETHER IT SOLVES YOUR PROBLEM ?",
    solve_problem_ok: "YES",
    solve_problem_no: "NO",
    feedback: "THANK YOU FOR YOUR FEEDBACK !",
    send_email: "PLEASE EDIT YOUR QUESTIONS AND SEND THEM TO",
    i_know: "I SEE"
  },

  // inform_detail: {
  //   event_message: "HELLO, {name}, [event] HAS STARTED, PLEASE LOG IN EMOMENT.NIKE.COM AS SOON AS POSSIBLE",
  //   session_message: "HELLO, {name}, THE [{name}] OF [{event}] ACTIVITY HAS STARTED, PLEASE LOG ON TO EMOMENT.NIKE.COM AS SOON AS POSSIBLE TO ATTEND"
  // },

  QA: {
    answer_list: 'ANSWER LIST',
    answer_user: 'ANSWER USER',
    answer_content: 'ANSWER CONTENT',
    answer_time: 'ANSWER TIME',
    ask_time: 'ASK TIME',
    ask_user: 'ASK USER',
    content: 'CONTENT',
    answer_status: 'ANSWER STATUS'
  },

  meeting_room_detail: {
    start_at: "START AT {time}",
    end_at: "END AT {time}",
    detail: "DETAIL",
    current_meeting: "CURRENT MEETING",
    current_meeting_id: "CURRENT MEETING ID",
    current_meeting_start_time: "CURRENT MEETING START TIME",
    current_meeting_end_time: "CURRENT MEETING END TIME",
    current_meeting_duration: "CURRENT MEETING DURATION",
    booking_list: "BOOKING LIST",
    event: "EVENT",
    session: "SESSION",
    session_date: "SESSION DATE",
    session_time: "SESSION TIME",
    meeting_history: "MEETING HISTORY",
    meeting_id: "MEETING ID",
    meeting_date: "MEETING DATE",
    meeting_time: "MEETING TIME",
    meeting_duration: "MEETING DURATION",
    duration_time_format: "{munites} MINs {seconds} SECONDs",
  },
  live_room_detail: {
    build_type: "BUILD TYPE",
    office_building: "OFFICE BUILDING",
    floor: "FLOOR",
    session_room: "SESSION ROOM NAME",
    session_room_num: "SESSION ROOM NUM",
    is_valid: "IS VALID",
    projection: "PROJECTION",
    desk_type: "DESK TYPE",
    max_attendee: "MAX ATTENDEE",
    edit_session_room: "EDIT SESSION ROOM",
    add_session_room: "ADD SESSION ROOM"
  },
  tag_list: {
    search_tag_kewords: "PLEASE ENTER TAG VALUE",
    tag_title: "TAG VALUE",
    add_tag_title: "ADD TAG",
    add_tag_input: "TAG",
    input_tag: "PLEASE ENTER TAG VALUE",
    add_account_group: "ADD ACCOUNT GROUP",
    search_company_keywords: "PLEASE ENTER COMPANY NAME",
    add_company: "ADD COMPANY",
    company_name: "COMPANY NAME",
    relation_event: "ASSOCIATED ACTIVITIES",
  },
  company: "COMPANY",
  company_list: {
    code: "ACCOUNT GROUP CODE",
    name: "ACCOUNT GROUP NAME",
    add_company: "ADD ACCOUNT GROUP",
    enter_code: "PLEASE ENTER ACCOUNT GROUP CODE",
    enter_name: "PLEASE ENTER ACCOUNT GROUP NAME",
  },
  user: {
    phone: "PHONE",
    email: "EMAIL",
    LOCATION: "LOCATION",
    COMPANY: "COMPANY",
    account_group: "ACCOUNT GROUP",
    CITY: "CITY",
    account: "ACCOUNT",
    password: "PASSWORD",
    name: "NAME",
    clear_openid: "CLEAR OPENID",
    disabled: "DISABLED",
    enabled: "ENABLED",
    prefix: "PREFIX",
    gender: "GENDER",
    is_disabled: "IS DISABLED",
    is_internal: "INTENRAL",
    only_internal: "ONLY INTERNAL",
    without_internal: "WITHOUT INTERNAL",
    TAG1: "DIVISION",
    TAG2: "CATEGORY",
    TAG3: "GENDER",
    TAG4: "CUSTOM TAG1",
    TAG5: "CUSTOM TAG2",
    is_main_owner: "EVENT OWNER",
    is_owner: "EVENT ADMIN",
    is_partner_contact: "PARTNER CONTACT",
    approve_by_pc: "PARTNER CONTACT",
    approve_by_pc_time: "PC APPROVAL TIME",
    approve_by_ea: "EVENT ADMIN",
    approve_by_ea_time: "EA APPROVAL TIME",
  },
  user_list: {
    download_template: "DOWNLOAD TEMPLATE",
    upload_user: "UPLOAD USER",
    add_user: "ADD USER",
  },
  videoManage: {
    video_manage: "VIDEO MANAGEMENT",
    upload_video: "UPLOAD VIDEO",
    merge_video: "MERGE VIDEOS",
    merge_chapter: "MERGE CHAPTER",
    choose_video: "SELECT VIDEO",
    video_name: "VIDEO NAME",
    upload_time: "UPLOAD TIME",
    tags: "TAGS",
    relation: "RELATION",
    season: "SEASON",
    account_group: "ACCOUNT GROUP",
    add: "ADD",
    confirm: "CONFIRM",
    remove: "REMOVE",
    merge: "MERGE",
    associate_session_input: "PLEASE ENTER EVENT NAME OR SESSION NAME",
    session_start_time: "SESSION START TIME",
    session_end_time: "SESSION END TIME",
    disassociation: "DISASSOCIATION",
    select_associated_property: "SELECT AN ASSOCIATED PROPERTY"
  },
  event_detail: {
    search_event_placeholder: "PLEASE ENTER THE EVENT NAME",
    send_agenda: "SEND AGENDA",
    whether_to_show: "WHETHER TO SHOW",
    video_title: "VIDEO TITLE",
    broadcaster: "BROADCASTER",
    add_broadcaster: "BIND BROADCASTER",
    partner_contact: "PARTNER CONTACT",
    start: "START EVENT",
    end: "END EVENT",
    delete_notice: "IF YOU WANT TO DELETE EVENT, PLEASE \"END EVENT\" FIRST.",
    name: "EVENT NAME",
    account_group: "ACCOUNT GROUP",
    start_time: "START TIME",
    end_time: "END TIME",
    invitation_url: "INVITATION URL",
    ADD_INVITATION: "ADD INVITATION",
    is_active: "IS ACTIVE",
    active: "ACTIVE",
    inactive: "INACTIVE",
    active_status: "ACTIVE",
    inactive_status: "INACTIVE",

    add: "ADD EVENT",
    date: "DATE",
    export_active_chat_record: "EXPORT ACTIVE CHAT RECORD",
    export_session_chat_record: "EXPORT SESSION CHAT RECORD",
    select_date_range: "SELECT DATE RANGE",
    detail: "EVENT DETAIL",
    add_event_admin: "ADD EVENT ADMIN",
    add_partner_contact: "ADD PARTNER CONTACT",
    switch_platform_notification: "SWITCH PLATFORM NOTIFICATION",
    switch_platform_minutes: "SWITCH PLATFORM MINUTES",
    switch_platform_time: "SWITCH PLATFORM TIME",
    switch_platform_preview: "PREVIEW",
    support_extensions: "SUPPORT FOR EXTENSIONS: {extensions}",
    countdown_template: "COUNTDOWN TEMPLATE",
    video_cover: "VIDEO COVER{index}",
    upload_video_cover_tip: "UPLOAD VIDEO COVER",
    seasonal_video: "SEASONAL VIDEO-{index}",
    seasonal_image: "SEASONAL IMAGE-{index}",
    switch_platform_preview_detail: "There is a problem with eMoment. We will continue the meeting after {minutes} minutes ({time}). Please login to the system through the website: {url}. <br/>We are very sorry for the inconvenience caused to you.",
    send_switch_platform_notification: "SEND SWITCH PLATFORM NOTIFICATION",
    tab: {
      "dashboard": "DASHBOARD",
      "report": "REPORT",
      "event_detail": "EVENT DETAIL",
      "sessions": "SESSIONS",
      "attendees": "ATTENDEES",
      "event_admin": "EVENT STAFF",
      "speakers": "SPEAKERS",
      "assistants": "SPECIALISTS",
      "speakers/assistants": "SPEAKERS&SPECIALIST",//  产品专家隐藏
      // "speakers/assistants":"SPEAKERS",
      "invitation": "EVENT INVITATION",
      "forecast_of_assets": "PRE-HEAT ASSET",
      "notify": "NOTIFY",
      "log": "LOG",
      "channels": "CHANNELS",
      "approval_list": "APPROVAL LIST",
      "advance": "ADVANCE",
      "notice": "NOTICE",
      "qa": "Q&A",
      "产品库": "ASSETS CENTER",
      "MDTF": "MDTF"
    },
    notice: {
      notice_type: "NOTICE TYPE",
      event: "EVENT NOTICE",
      session: "SESSION NOTICE",
      choose_session: "SELECT SESSION",
      title: "TITLE",
      input_title: "PLEASE ENTER NOTICE TITLE",
      content: "CONTENT",
      publisher: "PUBLISHER",
      is_draft: "IS PUBLISHED",
      due_time: "NOTICE TIME",
      reminder_type: "REMINDER TYPE",
      silence: "IMPLICIT PUSH",
      popup: "POP-UP PUSH",
      with_email_phone: "SMS/Email",
      send_immediately: "SEND NOW",
      appointment_time: "TIME APPOINTMENT",
      download_accessory: "DOWNLOAD ACCESSORY",
      media: "LINK",
      upload_media: "ADD LINK",
    },
    chart: {
      "attendee_status": "ATTENDEE STATUS",
      "session_type": "SESSION TYPE",
      "online_session": "ONLINE SESSION",
      "registration_qty": "REGISTRATION QTY",
      "daily_login_qty": "DAILY LOGIN QTY",
      "daily_session_qty": "DAILY SESSION QTY",
      "session_avg_qty": "AVG QTY PER SESSION",
    },
    report: {
      title: "DATA REPORT",
      last_time_at: "DEADLINE FOR STATISTICS: {time}",
      export: "EXPORT REPORT",
      refresh: "REFRESH",
      pc_approval: "Partner Contact APPROVAL REPORT",
      register_table: "REGISTRATION",
      register_table_approved: "APPROVED",
      register_table_rejected: "REJECTED",
      register_table_wait: "PENDING",
      approve_table: "APPROVAL",
      approve_table_left: "REMAIN",
      login_table: "LOGIN",
      login_table_login: "LOGGED IN",
      login_table_not_login: "NOT LOGGED IN",
      approve_status: "APPROVAL STATUS",
      event_login: "EVENT LOGIN DATA",
      actual_login: "ACTUAL LOGGED IN",
      no_login: "NOT LOGGED IN",
      session_login: "SESSION LOGIN DATA",
      session_login_description: "ACCUMULATED NUMBER OF ATTENDEES FROM SESSION START TIME, THE DATA IS SLIGHTLY DALAYED.",
      real_time_login: "REAL TIME LOGIN",
      real_time_login_description: "LOGIN DATA IN 5 MINUTES FROM [{time}].",
      account_group_login: "ACCOUNT GROUP LOGIN DATA",
      company_login: "COMPANY LOGIN DATA",
      user_status: "ATTENDEE STATUS STATISTICS",
      join_status: "SESSION STATUS",
      no_join_status: "LOGIN STATUS",
      no_company: "NO COMPANY",
    },
    main_title_image: "MAIN TITLE IMAGE",
    banner: "EVENT BANNER - {number}",
    poster_event_broadcast_image: "BROADCAST IMAGE",
    poster_event_countdown_image: "COUNTDOWN BACKGROUND IMAGE",
    poster_event_register_image: "REGISTER IMAGE",
    image_size: "- IMAGE SIZE: {size}",
    cropper_image_size: "IMAGE SIZE: {width} * {height}",
    compress_image_size: "COMPRESSED SIZE: {size} KB",
    upload_image_comments: "CLICK OR DRAG IMAGE HERE",
    upload_file_comments: "CLICK OR DRAG FILE HERE",
    session_default_image: "SEESION DEFAULT IMAGE",
    notify: "NOTIFY",
    add_notify: "ADD NOTIFY",
    notify_title: "NOTIFY TITLE",
    notify_is_published: "IS PUBLISHED",
    notify_is_publish: "IS PUBLISH",
    notify_success: "PUBLISH NOTIFY SUCCESSFULLY",
    notify_content: "NOTIFY CONTENT",
    notify_published: "PUBLISHED",
    notify_unpublished: "UNPUBLISHED",
    // 会议tab相关
    add_session: "ADD SESSION",
    download_session_template: "DOWNLOAD SESSION TEMPLATE",
    upload_sessions: "UPLOAD SESSIONS",
    advanced_options: {
      playback_switch: "PLAYBACK SWITCH",
      video_list: "VIDEO LIST",
      title: "ADVANCED OPTIONS",
      session_protect: "SESSION PROTECT",
      remove_protect: "REMOVE PROTECT",
      hint_session_protect: "CONFIRM TO PROTECT [{session_name}] MEETING?",
      hint_remove_protect: "CONFIRM RELEASE OF PROTECTION [{session_name}] MEETING?",
      session_title: "[{session_name}] ADVANCED OPTIONS",
      video_management: "PLAYBACK VIDEO MANAGEMENT",
      activity_introduction: "ACTIVITY INTRODUCTION",
      activity: "ACTIVITY",
      video_management_info: "CLICK OR DRAG THE VIDEO HERE TO UPLOAD",
      video_management_Tip: "FILE EXTENSIONS SUPPORTED: .mp4, .mov(1080P OR ABOVE)",
      upload_file_add: "FILE ADDED SUCCESSFULLY",
      upload_file_choose: "PLEASE SELECT THE FILE TO BE UPLOADED!",
      upload_file_mp4: "PLEASE SELECT A FILE IN MP4 OR MOV FORMAT!",
      upload_file_success: "FILE UPLOADED SUCCESSFULLY",
      upload_file_failed: "FILE UPLOAD FAILED",
      upload_file_loading1: "FILE UPLOADING...",
      upload_video_loading: "VIDEO UPLOADING...",
      upload_file_timeout: "FILE UPLOAD TIMEOUT!",
      upload_isUploading: "THERE ARE FILES UPLOADING!",
      upload_cancel_title: "THERE ARE FILES UPLOADING, ARE YOU SURE TO CANCEL？",
      update_success: "UPDATE SUCCESSFUL",
      delete_success: "DELETED SUCCESSFULLY",
      upload_success: "UPLOADED SUCCESSFULLY",
      try_later: "VIDEO TRANSCODING, PLEASE TRY AGAIN LATER",
      upload_failed_canResume: 'UPLOAD FAILED, CLICK TO CONTINUE',
      upload_failed: 'UPLOAD FAILED',
      add_video: "+ADD VIDEO",
      add_subtitle: "+ADD SUBTITLES",
      add_section: "ADD SECTION",
      delete_section: "DELETE SECTION",
      section: "CHAPTER",
      section_name: "CHAPTER NAME",
      download_chapter_template: "DOWNLOAD CHAPTER TEMPLATE",
      upload_chapter_template: "UPLOAD CHAPTER TEMPLATE",
      chapter_template: "CHAPTER TEMPLATE",
      upload_file_subtitle: "PLEASE SELECT A FILE IN VTT OR ASS FORMAT!",
      add_subtitle_success: "SUBTITLE ADDED SUCCESSFULLY",
      basic_setting: "BASIC SETTING",
      is_open: "IS OPEN",
      time_can_not_empty: "TIME CANNOT BE EMPTY",
      time_error0: "THE START TIME CANNOT BE LESS THAN THE CURRENT TIME",
      time_error: "THE START TIME CANNOT BE GREATER THAN THE END TIME",
      not_support_video: "YOUR BROWSER DOES NOT SUPPORT VIDEO PLAYBACK",
      get_speaker_ingest_address: "GET SPEAKER INGEST ADDRESS",
    },
    attendee: "ATTENDEE",
    attendee_count: "ATTENDEE COUNT",
    attendee_copy_to: "COPY TO",
    attendee_copy: "COPT ATTENDEE",
    add_to_session: "ADD TO SESSION",
    attendee_to_session: "ADD ATTENDEE TO SESSION",
    add_attendee_to_session: "ADD [{attendee_name}] TO BELOW SESSION(S)",
    confirm_add_attendee_to_session: "CONFIRM ADD [{attendee_name}] TO THE SELECTED SESSION(S) ON THE RIGHT?",
    choose_copy_attendee_to: "SELECT SESSION(S)",
    copy_attendee_from: "COPY ATTENDEE(S) FROM [{session_name}] TO BELOW SESSION(S)",
    upload_session_attendees: "UPLOAD EVENT ATTENDEES",
    download_session_attendee_template: "DOWNLOAD SESSION ATTENDEE TEMPLATE",
    download_all_attendee: 'DOWNLOAD EVENT ATTENDEE',
    add_attendee_from_attendees: "ADD ATTENDEE FROM ATTENDEE LIST",
    add_attendee_from_users: "ADD ATTENDEE FROM USER LIST",
    select_all_pre: "{count} ATTENDEES HAVE BEEN CHECKED ON THIS PAGE,",
    select_allUser_pre: "{count} USERS HAVE BEEN CHECKED ON THIS PAGE,",
    select_all_suf: "CHECK ALL {count} ATTENDEE IN THE LIST",
    select_allUser_suf: "CHECK ALL {count} USERS IN THE LIST",
    select_all_suf1: "ALL ATTENDEES({count}) IN THE LIST HAVE BEEN CHECKED,",
    select_allUser_suf1: "ALL USERS({count}) IN THE LIST HAVE BEEN CHECKED,",
    cancel_select: "UNCHECK",
    session_attendee_title: "[{session_name}] SESSION ATTENDEE",
    has_channel: "HAS CHANNEL",
    // 频道tab
    channel_name: "CHANNEL NAME",
    session_count: "SESSION COUNT",
    view_related_session: "VIEW RELATED SESSION",
    // 参会人tab
    invitation_status: "INVITATION STATUS",
    registration_status: "REGISTRATION STATUS",
    IS_CONFIRMED: "IS 'meeting_room'CONFIRMED",
    approve: "APPROVE",
    reject: "REJECT",
    confirmed_status: {
      "PENDING": "PENDING",
      "CONFIRMED": "CONFIRMED",
      "REJECTED": "REJECTED"
    },
    IS_BLOCK: "IS BLOCK",
    online_onsite: "ONLINE / ONSITE",
    online: "ONLINE",
    onsite: "ONSITE",
    approval_list: "APPROVAL LIST",
    download_approval_list: "DOWNLOAD APPROVAL LIST",
    upload_approval_list: "UPLOAD APPROVAL LIST",
    // 讲者tab
    ADD_SPEAKER: "ADD SPEAKER",
    ADD_ASSISTANT: "ADD SPECIALIST",
    invitation_speaker: "INVITE SPEAKER",
    invitation_assistant: "INVITE SPECIALIST",
    is_speaker: "IS SPEAKER",
    is_assistant: "IS SPECIALIST",
    // 新增event admin
    add_event_admin: "ADD EVENT ADMIN",
    // 会议信息/邀请tab
    ADD_MESSAGE_INVITATION: "ADD MESSAGE INVITATION",
    TITLE: "TITLE",
    SCHEDULE_TIME: "SPECIFIED TIME",
    LAST_UPDATE_TIME: "LAST UPDATED",
    SEND_STATUS: "SEND STATUS",
    START_SEND: "START SEND",
    // 活动日志tab
    EXPORT_EVENT_LOG: "EXPORT EVENT LOG",
    USER_NAME: "USER NAME",
    IP: "IP",
    LOG_TYPE: "LOG TYPE",
    LOG_TIME: "LOG TIME",
    MESSAGE: "MESSAGE",
    invite_event_admin: "INVITE EVENT ADMIN",
    invite_partner_contact: "INVITE PARTNER CONTACT",
    season: "SEASON",
    event_stage: 'EVENT STAGE'
  },

  invitation: {
    owner: "PARTNER CONTACT",
    limit: "LIMIT",
    expired_time: "EXPIRED TIME",
    resend_invitation: "RESEND INVITATION",
  },

  forecast_of_assets: {
    assets_name: "ASSETS NAME",
    upload_time: "UPLOAD TIME",
    assets_type: "ASSETS TYPE",
    video: "VIDEO",
    image: "IMAGE",
    set_the_cover: "SET THE COVER",
    view: "VIEW"
  },

  // session_detail页面
  session_detail: {
    SESSION_TYPE: "SESSION TYPE",
    confirm_copy_attendee_to_session: "CONFIRM COPY ATTENDEE TO SESSION",
    playback_time: "PLAYBACK TIME",
    preview_time: "PREVIEW TIME",
    enter_session_name: "PLEASE ENTER A SESSION NAME",
    select_session_date: "PLEASE SELECT THE DATE OF THE MEETING",
    select_session_time: "PLEASE SELECT THE MEETING TIME",
    select_speaker: "PLEASE SELECT THE SPEAKER",
    approach_time: "APPROACH TIME",
    select_enter_time: "PLEASE SELECT AN ENTRY TIME",
    early_enter: "ENTER {minutes} MINUTES EARLY",
    select_assistant: "PLEASE SELECT THE SPECIALIST",
    session_type_detail: {
      ONSITE: "EMOMENT ONSITE",
      BROADCAST: "EMOMENT BROADCAST-LIVE",
      "INTERACTIVE MEETING": "EMOMENT MEETING-ZOOM",
      PLAYBACK: "EMOMENT PLAYBACK",
      RECORDED: "EMOMENT BROADCAST-RECORD",
      BROADCAST_CASTER: "EMOMENT BROADCAST-LINK",
      ACTIVITY: "EMOMENT ACTIVITY",
    },
    activity_status: "IS THE ACTIVITY OVER",
    ADD_SESSION: "ADD SESSION",
    edit_session: "SESSION DETAIL",
    SESSION_DESCRIPTION: "SESSION DESCRIPTION",
    SESSION_COMPANY: "ACCOUNT GROUP",
    SPEAKER: "SPEAKER",
    WHITEBOARD: "WHITEBOARD",
    WATERMARK: "WATERMARK",
    WATERMARK_TYPE: "WATER TYPE",
    SESSION_HOME_IMAGE: "SESSION HOME IMAGE",
    session_countdown_image: "SESSION COUNTDOWN IMAGE",
    BROADCAST: "BROADCAST",
    RECORDED: "RECORDED",
    BROADCAST_IMAGE: "BROADCAST IMAGE",
    ZOOM_CONFIG: "ZOOM CONFIG",
    ALIYUN_PUSH_ADDRESS: "ALIYUN PUSH ADDRESS",
    BROADCAST_IS_START: "BROADCAST IS START",
    ENABLE_PARTICIPANT_VIDEO: "ENABLE PARTICIPANT VIDEO",
    IS_WEBINAR: "IS WEBINAR",
    ENABLE_SCREEN_SHARING: "ENABLE SCREEN SHARING",
    ENABLE_WAITING_ROOM: "ENABLE WAITING ROOM",
    ENABLE_JOIN_BEFORE_HOST: "ENABLE JOIN BEFORE HOST",
    JOIN_BEFORE_HOST_TIME: "JOIN BEFORE HOST TIME",
    ANYTIME: "ANYTIME",
    BEFORE_5min: "BEFORE 5min",
    BEFORE_10min: "BEFORE 10min",
    choose_channel: "CHOOSE CHANNEL",
    new_channel: "NEW CHANNEL",
    choose_channel_input: "INPUT CHANNEL NAME",
    new_channel_name: "CHANNEL NAME",
    default_watermark: "COLUMNS: 5*3, TRANSPARENCY: 50%",
    zoom_watermark: "COLUMNS: 7, 6, 7, TRANSPARENCY: 50%",
    watermark_9_4: "COLUMNS: 9*4, TRANSPARENCY: 50%",
    video_name: "VIDEO NAME",
    video_duration: "VIDEO DURATION",
    activity_media: "ACTIVITY MEDIA",
  },

  update_me: {
    get_code: "GET VERIFICATION CODE",
    count_down: "TRY AGAIN, AFTER {second}S",
  },

  register: {
    division: "DIVISION",
    category: "CATEGORY",
    gender: "GENDER",
    tag1: "DIVISION",
    tag2: "CATEGORY",
    tag3: "GENDER",
    tag4: "CUSTOM TAG1",
    tag5: "CUSTOM TAG2",
    confirm_user_information: "CONFIRM USER INFORMATION",
    name: "NAME",
    gender: "GENDER",
    select_gender: "SELECT GENDER",
    male: "MALE",
    female: "FEMALE",
    phone: "PHONE NUMBER",
    old_phone: "OLD PHONE NUMBER",
    new_phone: "NEW PHONE NUMBER",
    old_email: "OLD EMAIL",
    new_email: "NEW EMAIL",
    validation_code: "VALIDATION CODE",
    get_validataion_code: "GET CODE",
    enter_validation_code: "PLEASE ENTER VALIDATION CODE",
    email: "EMAIL",
    change: "CHANGE",
    input_phone: "PHONE",
    input_name: "NAME",
    input_email: "EMAIL",
    input_city: "CITY",
    select_divistion: "SELECT DIVISTION",
    select_category: "SELECT CATEGORY",
    select_tag_gender: "SELECT GENDER",
    select_company: "SELECT COMPANY",
    input_location: "INPUT LOCATION",
    upload_avatar: "UPLOAD AVATAR",
    account_group: "ACCOUNT GROUP",
    select_account_group: "SELECT ACCOUNT GROUP",
    area: "LOCATION",
    city: "CITY",
    company: "COMPANY",
    online: "ONLINE",
    onsite: "ONSITE",
    online_onsite_description: "SUPPORTING MULTIPLE SELECTION.<br/>BUT PLEASE CHOOSE ONLINE/ONSITE ACCORDING TO YOUR ACTUAL SITUATION.",
    language: "LANGUAGE",
    select_language: "SELECT LANGUAGE",
    register: "SIGN UP",
    privacy: "I AGREE TO NIKE'S <a class='privacy_link' href='/Privacy' target='_blank'>PRIVACY POLICY</a>",
    reg_pending_name: "DEAR {user_name}, ",
    reg_pending: "YOU HAVE ALREADY REQUESTED TO JOIN EVENT [{event_name}], PLEASE WAIT FOR PARTNER CONTACT / EVENT ADMIN APPROVAL.",
    update_form: "UPDATE REGISTRATION FORM",
  },

  // invitationdetail 页面
  invitation_detail: {
    TITLE: "TITLE",
    MESSAGE: "MESSAGE",
    EVENT: "EVENT",
    SESSION: "SESSION",
    SCHEDULE_DATETIME: "SCHEDULE_DATETIME",
    SELECT_DATE_AND_TIME: "SELECT_DATE_AND_TIME",
    STATUS: "STATUS",
    CONTENT: "CONTENT"
  },

  // sensitive word page
  sensitive_list: {
    title: "SENSITIVE WORD",
    download_template: "SENSITIVE WORDS TEMPLATE",
    upload: "UPLOAD SENSITIVE WORDS",
    keyword: "Keyword",
    add: "ADD SENSITIVE WORD",
    no_sensitive_word_list: "PLEASE SEARCH TO SHOW SENSITIVE WORDS.",
  },

  // admin list
  admin_list: {
    title: "ADMIN LIST",
    add: "ADD ADMIN",
    name: "NAME",
    phone: "PHONE",
    email: "EMAIL",
    role: "ROLE",
    admin: "SYSTEM ADMIN",
    event_admin: "EVENT ADMIN",
    as_admin: "ADMIN ROLE",
    as_event_admin: "EVENT ADMIN ROLE",
    delete_success: "DELETE SUCCESSFULLY!",
  },

  // report viewer list
  report_viewer: {
    title: "REPORT VIEWER",
    report_viewer: "REPORT VIEWER",
    company_group:'COMPANY GROUP',
    add: "ADD REPORT VIEWER",
    name: "NAME",
    phone: "PHONE",
    email: "EMAIL",
    role: "ROLE",
    delete_success: "DELETE SUCCESSFULLY!",
    as_report_viewer: "REPORT VIEWER",
  },

  //错误信息
  errMsg: {
    "chapter type error": "THE CHAPTER TYPE CAN ONLY ENTER SKU/CONTENT !",
    "file error": "{name} INCORRECT FILE FORMAT!",
    "the uploaded image cannot exceed 500kb": "THE UPLOADED IMAGE CANNOT EXCEED {size}!",
    "the image you uploaded is not in the right format": "THE IMAGE YOU UPLOADED IS NOT IN THE RIGHT FORMAT, THE IMAGE ONLY SUPPORTS: JPG, PNG, JPEG FORMAT!",
    "unauthorized": "LOGIN TIMED OUT, PLEASE LOG IN AGAIN.",
    "the session room name must be unique": "THE SESSION ROOM NAME MUST BE UNIQUE.",
    "the meeting room name cannot be empty": "THE SESSION ROOM NAME CANNOT BE EMPTY.",
    "the session room number must be unique": "THE SESSION ROOM NUMBER MUST BE UNIQUE.",
    "meeting room name and room number cannot be repeated": "SESSION ROOM NAME AND ROOM NUMBER CANNOT BE REPEATED。",
    "the session name must be unique": "THE SESSION NAME MUST BE UNIQUE.",
    "the session time must be unique": "THE SESSION TIME MUST BE UNIQUE.",
    "session date allow empty": "SESSION DATE ALLOW EMPTY.",
    "company code not allow empty": "ACCOUNT GROUP CODE NOT ALLOW EMPTY.",
    "company name not allow empty": "ACCOUNT GROUP NAME NOT ALLOW EMPTY.",
    "document type allow empty": "DOCUMENT TYPE ALLOW EMPTY.",
    "document state allow empty": "DOCUMENT STATE ALLOW EMPTY.",
    "document name allow empty": "DOCUMENT NAME ALLOW EMPTY.",
    "document content allow empty": "DOCUMENT CONTENT ALLOW EMPTY.",
    "question allow empty": "QUESTION ALLOW EMPTY.",
    "event stage allow empty": "EVENT STAGE ALLOW EMPTY",
    "answer allow empty": "ANSWER ALLOW EMPTY.",
    "you need to upload a file in order to submit": "YOU NEED TO UPLOAD A VIDEO IN ORDER TO SUBMIT",
    "language environment allow empty": "LANGUAGE ENVIRONMENT ALLOW EMPTY.",
    "company name or company code may be duplicates.": "ACCOUNT GROUP NAME OR ACCOUNT GROUP CODE MAY BE DUPLICATES.",
    "this company in use.": "THIS ACCOUNT GROUP IN USE.",
    "this company not available": "THIS ACCOUNT GROUP NOT AVAILABLE.",
    "this room is in use and cannot be deleted": "THIS ROOM IS IN USE AND CANNOT BE DELETED",
    "company name cannot be duplicates": "ACCOUNT GROUP NAME CANNOT BE DUPLICATES.",
    "please complete your personal info": "PLEASE COMPLETE YOUR PERSONAL INFO.",
    "incorrect email format": "INCORRECT EMAIL FORMAT.",
    "wrong file format": "WRONG FILE FORMAT.",
    "no file, or format is in correct": "NO FILE, OR FILE FORMAT IS INCORRECT.",
    "name not allow empty": "USER NAME NOT ALLOW EMPTY.",
    "channel name not allow empty": "CHANNEL NAME NOT ALLOW EMPTY",
    "no_phone": "PHONE NUMBER CANNOT BE EMPTY.",
    "room name cannot be empty": "ROOM NAME CANNOT BE EMPTY.",
    "room number cannot be empty": "ROOM NUMBER CANNOT BE EMPTY.",
    "building cannot be empty": "BUILDING CANNOT BE EMPTY。",
    "build type cannot be empty": "BUILD TYPE CANNOT BE EMPTY.",
    "floor cannot be empty": "FLOOR CANNOT BE EMPTY.",
    "no_email": "EMAIL CAN'T BE EMPTY.",
    "no_validation_code": "VALIDATION CODE CAN'T BE EMPTY.",
    "wrong validation code, please check it again.": "WRONG VALIDATION CODE, PLEASE CHECK IT AGAIN.",
    "phone existed": "PHONE EXISTED.",
    "email existed": "EMAIL EXISTED.",
    "account existed": "ACCOUNT EXISTED.",
    "acount/pwd, phone, email not allow all empty": "ACOUNT/PWD, PHONE, EMAIL NOT ALLOW ALL EMPTY.",
    "no user": "NO USER.",
    "unable find user": "UNABLE FIND USER.",
    "no file found or file type error": "NO FILE FOUND OR FILE TYPE ERROR.",
    "convert cartoon error": "CONVERT CARTOON ERROR.",
    "old/new password can\'t be empty": "OLD/NEW PASSWORD CAN'T BE EMPTY.",
    "wrong old password": "WRONG OLD PASSWORD.",
    "event name can not be empty": "EVENT NAME CAN NOT BE EMPTY.",
    "event start date or end date can not be empty": "EVENT START DATE OR END DATE CAN NOT BE EMPTY.",
    "notify title not empty": "NOTIFY TITLE CAN'T BE EMPTY.",
    "notify content not empty": "NOTIFY CONTENT CAN'T BE EMPTY.",
    "OKTA_Login_Fail": "OKTA LOGIN FAILED, PLEASE LOGIN AGAIN.",
    "account group can not be empty": "ACCOUNT GROUP CAN'T BE EMPTY!",
    'existed role': "THIS USER ALREADY HAS THIS ROLE!",
    "no channel": "THIS CHANNEL CAN'T BE FOUND!",
    "channel in use": "THIS CHANNEL IS IN USE, IT CAN'T BE DELETED!",
    "event owner cannot be partner contact": "THIS USER IS ALREADY AN EVENT ADMIN AND CANNOT BE SET UP AS A PARTNER CONTACT.",
    "NAME AND EMAIL CANNOT BE EMPTY.": "NAME AND EMAIL CANNOT BE EMPTY.",
    "name, phone, email, company required": "NAME, PHONE AND EMAIL ARE REQUIRED.",
    "invitation_owner_required": "INVITATION OWNER IS REQUIRED.",
    "invitation_limit_required": "INVITATION LIMIT IS REQUIRED.",
    "invitation_expired_time_required": "INVITATION EXPIRED TIME IS REQUIRED.",
    "invitation_company_required": "INVITATION COMPANY IS REQUIRED.",
    "sensitive_word_cannot_empty": "SENSITIVE WORD CANNOT BE EMPTY.",
    "event_name_required": "EVENT NAME IS REQUIRED.",
    "start_end_time_required": "SESSION START TIME AND END TIME CANNOT BE EMPTY.",
    "start_time_required": "SESSION START TIME CANNOT BE EMPTY.",
    "playback_time_required": "PLAYBACK TIME CANNOT BE EMPTY.",
    "end_time_required": "SESSION EMD TIME CANNOT BE EMPTY.",
    "diff_playback_time": "THE END TIME OF THE MEETING MUST BE GREATER THAN THE START TIME OF THE MEETING",
    "the_start_time_must_be_different_from_the_end_time": "THE START TIME MUST BE DIFFERENT FROM THE END TIME.",
    "sensitive_word_duplicated": "SENSITIVE WORD CANNOT DUPLICATE.",
    "no attendee need to approve": "NO ATTENDEE NEED TO BE APPROVED.",
    "nike_email_format_error": "EMAIL FORMAT ERROR.",
    "email_format_error": "EMAIL FORMAT ERROR.",
    "no room for this session.": "NO ZOOM MEETING ROOM FOR THIS SESSION.",
    "already partner contact": "THIS USER IS ALREADY PARTNER CONTACT.",
    "no role to delete event": "NO ROLE TO DELETE THIE EVENT.",
    "partner_contact_no_nike_email": "PLEASE DO NOT INVITE NIKE EMPLOYEES AS PARTNER CONTACT",
    "must_nike_email": "PLEASE INPUT NIKE EMAIL.",
    "name, email, account_group required": "NAME, EMAIL AND ACCOUNT GROUP ARE REQUIRED.",
    "not_nike_email_phone_required": "PHONE NUMBER IS REQUIRED.",
    "session_name_required": "SESSION NAME IS REQUIRED.",
    "session_assistant_required": "SPECIALIST IS REQUIRED",
    "session_speaker_required": "SPEAKER IS REQUIRED.",
    "broadcast_channel_required": "SESSION BROADCAST CHANNEL IS REQUIRED.",
    "no_pc_in_invitation": "NO PARTNER CONTACT IN THIS INVITATION.",
    "this session already contains this attendee": "ALREADY IN THIS SESSION!",
    "tag_value existed": "TAG VALUE EXISTED.",
    "phone, email not allow all empty": "PHONE, EMAIL NOT ALLOW ALL EMPTY!",
    "switch_platform_required": "MINUTES AND TIME ARE REQUIRED.",
    "unable to parse the file.": "UNABLE TO PARSE THE FILE.",
    "company code existed": "COMPANY CODE EXISTED",
    "tag value duplicated.": "TAG VALUE EXISTED!",
    "no_session_selected": "PLEASE SELECT A SESSION",
    "no_attendee_selected": "PLEASE SELECT A ATTENDEE",
    "failed to upload template": "FAILED TO UPLOAD TEMPLATE!",
    "this speaker is already existed": "THIS SPEAKER IS ALREADY EXISTED",
    "notice title allow empty": "THE NOTICE TITLE CANNOT BE EMPTY.",
    "file_document_error": "{file_name} DO NOT ALLOW TO UPLOAD.",
    "file_document_size_error": "{file_name} FILE SIZE TOO BIG TO UPLOAD.",
    "upload the media fail": "FAILED TO UPLOAD THE ATTACHMENT.",
    "file_size_error": "THE SIZE OF THE UPLOADED FILE CANNOT EXCEED {file_size}。",
    "answer required": "ANSWER CANNOT BE EMPTY.",
    "no chat history": "NO CHAT HISTORY",
    "not registrable": "THIS MOVEMENT IS OVER REGISTER TIME AND NEW USERS CANNOT BE ADDED.",
    "the session time cannot be within the preview time": "THE START TIME OF THE SESSION MUST BE LATER THAN THE END TIME OF THE PREVIEW",
    "the start time of the playback must be later than the end time of the session": "THE START TIME OF THE PLAYBACK MUST BE LATER THAN THE END TIME OF THE SESSION",
    "sport_time_error": "THE START TIME OF THE SPORT MUST BE LONGER THAN THE END TIME OF REGISTRATION",
    "sport_time_error_by_today": "THE START TIME OF THE SPORT MUST BE TODAY"
  },
  //成功提醒
  successMsg: {
    "created success": "CREATED SUCCESS!",
    "merge success": "MERGE SUCCESS",
    "open success": "OPEN SUCCESS!",
    "close success": "CLOSE SUCCESS!",
    "association success": "ASSOCIATION SUCCESS!",
    "disassociation success": "DISASSOCIATION SUCCESS!",
    "reset password successfully": "RESET PASSWORD SUCCESSFULLY!",
    "send success": "THE PROMPT HAS BEEN SENT SUCCESSFULLY, AND WILL NOT BE PROMPTED IN 5 MINUTES!",
    "update_qa_success": 'UPDATE Q&A SUCCESS',
    "change company name successfully": "CHANGE ACCOUNT GROUP NAME SUCCESSFULLY!",
    "upload success": "UPLOAD SUCCESS!",
    "delete section successfully": "DELETE SECTION SUCCESSFULLY!",
    "set cover successfully": "SET COVER SUCCESSFULLY",
    "upload the session successfully": "UPLOAD THE SESSION SUCCESSFULLY!",
    "upload the section successfully": "UPLOAD THE SECTION SUCCESSFULLY",
    "upload the media successfully": "UPLOAD THE ATTACHMENT SUCCESSFULLY!",
    "add company successfully": "ADD ACCOUNT GROUP SUCCESSFULLY!",
    "delete company successfully": "DELETE ACCOUNT GROUP SUCCESSFULLY!",
    "update user successfully": "UPDATE USER SUCCESSFULLY!",
    "add user successfully": "ADD USER SUCCESSFULLY!",
    "import user list successfully": "IMPORT USER LIST SUCCESSFULLY!",
    "send_email_validation_success": "THE VERIFICATION CODE HAS BEEN SENT TO YOUR EMAIL ADDRESS, PLEASE CHECK IT!",
    "clear openid successfully": "CLEAR OPENID SUCCESSFULLY!",
    "update notify successfully": "UPDATE NOTIFY SUCCESSFULLY!",
    'update success': "UPDATE SUCCESS!",
    "add notify successfully": "ADD NOTIFY SUCCESSFULLY!",
    "update event successfully": "UPDATE EVENT SUCCESSFULLY!",
    "upload sensitive word success": "UPLOAD SENSITIVE WORDS SUCCESSFULLY!",
    "add sensitive word successfully": "ADD SENSITIVE WORD SUCCESSFULLY!",
    "delete_admin_success": "DELETE ADMIN SUCCESSFULLY!",
    "copy event invitation url successfully": "COPY EVENT INVITATION URL SUCCESSFULLY!",
    "copy aliyun push address successfully": "COPY ALIYUN PUSH ADDRESS SUCCESSFULLY!",
    "delete_event_success": "DELETE EVENT SUCCESSFULLY!",
    "delete_event_admin_success": "DELETE EVENT ADMIN SUCCESSFULLY!",
    "delete_report_viewer_success": "DELETE REPORT VIEWER SUCCESSFULLY!",
    "copy_attendee_success": "COPY ATTENDEES SUCCESSFULLY!",
    "add_to_session_success": "ADD TO SESSIONS SUCCESSFULLY!",
    "copy_session_success": "COPY SESSION SUCCESS!",
    "session_protect_success": "SESSION PROTECT SUCCESS",
    "remove_protect_success": "REMOVE SESSION PROTECT SUCCESS",
    "add_session_success": "ADD SESSION SUCCESS!",
    "update_session_success": "UPDATE SESSION SUCCESS!",
    "delete_channel_success": "DELETE CHANNEL SUCCESSFULLY!",
    "ADD PARTNER CONTACT SUCCESSFULLY.": "ADD PARTNER CONTACT SUCCESSFULLY.",
    "delete_partner_contact_success": "DELETE PARTNER CONTACT SUCCESSFULLY.",
    "INVITE EVENT ADMIN SUCCESSFULLY.": "INVITE EVENT ADMIN SUCCESSFULLY.",
    "ADD EVENT ADMIN SUCCESSFULLY.": "ADD EVENT ADMIN SUCCESSFULLY.",
    "INVITE PARTNER CONTACT SUCCESSFULLY.": "INVITE PARTNER CONTACT SUCCESSFULLY.",
    "add_invitation_success": "CREATE INVITATION CODE SUCCESSFULLY.",
    "edit_invitation_success": "UPDATE INVITATION CODE SUCCESSFULLY.",
    "resend_invitation_success": "RESEND INVITATION CODE SUCCESSFULLY.",
    "INVITE SPEAKER SUCCESSFULLY.": "INVITE SPEAKER SUCCESSFULLY.",
    "INVITE ASSISTANT SUCCESSFULLY.": "INVITE SPECIALIST SUCCESSFULLY.",
    "delete_success": "DELETE SUCCESSFULLY!",
    "add_success": "ADD SUCCESSFULLY!",
    "edit_success": "EDIT SUCCESSFULLY!",
    "send_success": "SEND SUCCESSFULLY!",
    "add_admin_success": "SET ADMIN SUCCESSFULLY!",
    "add_event_admin_success": "SET EVENT ADMIN SUCCESSFULLY!",
    "add_report_viewer_success": "ADD REPORT VIEWER SUCCESSFULLY!",
    "create_session_room_success": "ADD SESSION ROOM SUCCESSFULLY!",
    "update_session_room_success": "UPDATE SESSION ROOM SUCCESS!",
    "delete_session_room_success": "DELETE SESSION ROOM SUCCESS!",
    "send_switch_notification_success": "SEND SWITCH PLATFORM NOTIFICATION SUCCESSFULLY!",
  },
  // 警告提醒
  warningMsg: {
    "there is currently no video for this document": "THERE IS CURRENTLY NO VIDEO FOR THIS DOCUMENT！",
    "you have not selected participants to notify": "YOU HAVE NOT SELECTED PARTICIPANTS TO NOTIFY！",
    "check out the synthetic results": "CHECK OUT THE SYNTHETIC RESULTS!",
    "total video duration should be shorter than session duration": "TOTAL VIDEO DURATION SHOULD BE SHORTER THAN SESSION DURATION."
  },
  //提示信息
  confirmMsg: {
    "reset_pwd": "YOU DO NOT HAVE A PASSWORD AND CANNOT RESET IT",
    "whether to send the schedule of event to the participants by email": "SEND [{event}] EVENT AGENDA TO ATTENDEES BY EMAIL?",
    "confirm that it matches the meeting content": "THIS IS A RECORDED VIDEO, PLEASE CONFIRM THAT IT MATCHES THE MEETING CONTENT",
    "confirm linking meeting to video": "CONFIRM LINKING [XXX] SESSION TO VIDEO?",
    "confirm linking video to session": "CONFIRM LINKING [XXX] VIDEO TO SESSION?",
    "you cannot recover company while you deleted": "YOU CANNOT RECOVER ACCOUNT GROUP WHILE YOU DELETED.",
    "do you confirm clear openid": "DO YOU CONFIRM CLEAR OPENID?",
    "confirm_delete_admin.admin": "DO YOU CONFIRM TO DELETE THIS ADMIN?",
    "confirm_delete_admin.event_admin": "IF YOU WANT TO REMOVE THIS EVENT ADMIN ROLE, THE ROLE IN EVENTS WILL BE REMOVED SIMULTANEOUSLY. DO YOU CONFIRM?",
    "confirm_delete_admin.report_viewer": "DO YOU CONFIRM TO DELETE THIS REPORT VIEWER?",
    "confirm_delete_event": "DO YOU CONFIRM TO DELETE THIS EVENT?",
    "confirm_delete_event_admin": "DO YOU CONFIRM TO DELETE THIS [EVENT ADMIN]?",
    "confirm_delete_channel": "DO YOU CONFIRM TO DELETE THIS CHANNEL?",
    "confirm_delete_partner_contact": "DO YOU CONFIRM TO DELETE THIS [PARTNER CONTACT]?",
    "confirm_delete_speaker": "DO YOU CONFIRM TO DELETE THIS SPEAKER?",
    "confirm_delete_assistant": "DO YOU CONFIRM TO DELETE THIS SPECIALIST?",
    "confirm_delete_attendee": "DO YOU CONFIRM TO DELETE THIS ATTENDEE?",
    "confirm_delete_session": "DO YOU CONFIRM TO DELETE THIS SESSION?",
    "confirm_publish_notify": "DO YOU CONFIRM TO PUBLISH THIS NOTIFY?",
    "confirm_refresh_account": "DO YOU CONFIRM TO REFRESH THE MEETING ROOM ACCOUNT?",
    "confirm_delete_tag": "DO YOU CONFIRM TO DELETE THIS TAG?",
    "confirm_send_switch_notification": "DO YOU CONFIRM TO SEND SWITCH PLATFORM TO ALL ATTENDEES IN THIS EVENT?",
    "select_all_confirm": "CONFIRM ADD ALL ATTENDEES TO THE SESSION?",
    "select_allUser_confirm": "CONFIRM ADD ALL USERS TO THE SESSION?",
    "session_protect": "THERE ARE PROTECTED SESSIONS IN THIS EVENT, PLEASE CONTACT THE EVENT OWNER TO REMOVE THE SESSION PROTECTION BEFORE DELETING IT!",
    "confirm_delete_live_meeting_room_group": "ARE YOU SURE YOU WANT TO DELETE THE [{live_meeting_room}] MEETING ROOM?",
    "confirm_delete_the_medial": "ARE YOU SURE YOU WANT TO DELETE THE {medial_type}?",
    "confirm_delete_account": "ARE YOU SURE YOU WANT TO DELETE THE [{account}] ACCOUNT GROUP?",
    "confirm_delete_company": "ARE YOU SURE YOU WANT TO DELETE THE [{company}] COMPANY?",
    "confirm_delete_notice": "ARE YOU SURE YOU WANT TO DELETE THE [{NAME}] NOTICE?",
    "confirm_not_have_KIT": "PLEASE CONFIRM THAT THE UPLOADED LINK DOES NOT INVOLVE KIT CONTENT!",
    "unbind session confirm": "ARE YOU SURE YOU WANT TO UNBUNDLE THE [{session}] CONFERENCE FROM THE [{channel}] CHANNEL?",
  },
  check_rules: {
    '活动工作人员': 'EVENT STAFF',
    '会议邀请': 'MEETING INVITATIONS',
    '活动详情': 'EVENT DETAILS',
    '参会人': 'ATTENDEE',
    '讲者': 'SPEAKER',
    '会议': 'SESSION',
    '是否维护至少一个活动管理员': 'Whether to maintain at least one active administrator',
    '是否添加会议邀请': 'Whether to add a meeting invitation',
    '邀请人数是否少于50人': 'Whether the number of invitations is less than 50',
    '邀请有效期是否超过活动结束日期': 'Whether the invitation is valid beyond the event end date',
    '点击“重新发送邀请码”的次数': 'The number of times to click "Resend invitation code"',
    '是否维护预告视频': 'Whether to maintain teaser videos',
    '是否维护预告图片': 'Whether to maintain teaser images',
    '所有审批表内的人员状态是否无“待定”': 'Whether the status of the person in all approval forms is not "pending"',
    '所有审批表内的人员是否选择至少一个“参会方式”': 'Whether all people on the approval form have selected at least one "Participation Mode"',
    '参会人/所有参会人是否都维护了会议': 'Whether the meeting/all attendees maintained the meeting',
    '参会人/所有参会人的会议类型是否与参加权限匹配（线上/现场）': 'Whether the meeting type of the participants/all participants matches the participation permissions (online/on-site)',
    '参会人是否少于50人': 'Whether there are fewer than 50 participants',
    '讲者是否关联至少一个会议': 'Whether the speaker is associated with at least one meeting',
    '会议日期是否在活动期间': 'Whether the meeting date is during the event',
    '会议/会议通用检查/会议时间是否早于9:00': 'Meeting/meeting general check/meeting time is earlier than 9:00',
    '会议/会议通用检查/会议时间是否晚于18:00': 'Meeting/meeting general check/meeting time is later than 18:00',
    '会议的参会人是否少于50人': 'Whether the meeting has fewer than 50 participants',
    '现场会议-参会人数是否大于会议室容纳人数': 'Live meeting - whether the number of participants is larger than the room capacity',
    '是否在直播会议中维护了线下会议室': 'Whether the offline meeting room was maintained during the live meeting',
    '是否在直播会议中维护了提前进场时间': 'Whether early entry times are maintained in live meetings',
    '参会人参加会议的权限是否与参加会议类型匹配': 'Whether the participant\'s permission to attend the meeting matches the type of meeting attended',
    '是否在录播会议中维护了线下会议室': 'Whether the offline meeting room is maintained in the recorded meeting',
    '是否在录播会议中维护了提前进场时间': 'Whether early entry times are maintained in recorded meetings',
    '是否在互动会议中维护了线下会议室': 'Whether the offline meeting room is maintained in the interactive meeting',
    '是否在互动会议中维护了提前进场时间': 'Whether early entry times are maintained in interactive meetings',
    '不确定会议室时可维护为TBD选项': 'Maintainable TBD option when unsure of the meeting room',
    '产品专家必填': 'Product expert is required',
    '水印是否开启': 'Whether the watermark is turned on',
    '是否选择直播线路': 'Whether to select a live stream',
    '是否绑定频道': 'Whether to bind a channel',
    '同一频道内是否存在时间冲突的会议安排': 'Whether there are conflicting meeting schedules within the same channel',
    '录播、重播会议视频时长是否大于会议时长': 'Whether the video duration of the recording and replaying meeting is greater than the duration of the meeting',
    '互动会议是否分配会议室': 'Whether the interactive meeting is assigned a conference room',
    '讲者邮箱是否为@nike.com': 'Whether the speaker\'s email address is @nike.com',
    '详情中是否上传会议视频': 'Whether to upload a meeting video in the details',
    '是否上传字幕': 'Whether to upload subtitles',
    '重播会议是否开启重播': 'Whether to enable replay of the meeting',
    '是否维护重播时间': 'Whether to maintain replay time'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en-us.js